module.exports = __webpack_public_path__ + "files/0332ec8a7a7259947a276d5dab93a880.png";